const newMapList = new Map([
  [
    1,
    {
      name: "$input",
      props: {
        maxlength: "240",
      },
    },
  ],
  [
    2,
    {
      name: "textarea",
      props: {
        maxlength: "4000",
      },
    },
  ],
  [
    3,
    {
      name: "$select",
      props: {
        clearable: true,
      },
      options: [],
    },
  ],
  [
    4,
    {
      name: "$select",
      props: {
        clearable: true,
        multiple: true,
      },
      options: [],
    },
  ],
  [
    6,
    {
      name: "$input",
      props: {
        type: "date",
        //   labelFormat: 'yyyy-MM-dd HH:mm:ss'
        // labelFormat: 'yyyy-MM-ddThh:mm:ss',
        // valueFormat: 'yyyy-MM-ddThh:mm:ss',
        transfer: true,
      },
    },
  ],
  [
    7,
    {
      name: "$input",
      props: {
        type: "number",
        clearable: true,
      },
    },
  ],
  [
    10,
    {
      name: "$input",
      props: {
        type: "number",
        clearable: true,
      },
    },
  ],
]);

const setColumnItem = (item) => {
  const { id, name, uiType, listValue, required } = item;

  return {
    title: name,
    field: "pre" + id,
    uiType,
    listValue,
    required,
    editRender: newMapList.get(uiType),
  };
};

export const getAttriColumn = (arr) => {
  const list = arr.map((item) => setColumnItem(item));
  return list;
};

const setRowItem = (item, column) => {
  const { val = "", id, ids } = item,
    { uiType } = column;

  return val;
};

export const setSubDataItemVal = (item, column) => {
  const { uiType } = column;
  let val;
  if (uiType === 6) {
    console.log(item);
    const [str] = item.split("T");
    if (!str) {
      return "";
    }
    val = str + "T00:00:00";
    return val;
    // val = new Date(item)
    // return val;
  }
  return item;
};

export const getAttriData = (arr, columns) => {
  console.log(columns, arr);
  const fieldList = columns.map((i) => i.field);
  const list = arr.map((element) => {
    const { cells, rowId } = element,
      obj = {};
    cells.forEach((item, index) => {
      const key = fieldList[index];
      obj[key] = setRowItem(item, columns[index]);
    });
    obj["rowId"] = rowId;
    return obj;
  });
  return list;
};
